import React from "react";
import styles from "./HeroTagline.module.scss";

const HeroTagline = () => {
    return (
        <section className={styles.heroTagline}>
            <div className={styles.titleBlock}>
                <h1 className={styles.heading}>
                    TURN <span className={styles.highlight}>YOUR TV</span> INTO
                    <br />
                    A GAME SHOW!
                </h1>
                <p className={styles.subtitle}>Everyone plays from their phone</p>
                <p className={styles.subSubtitle}>
                    Buy once. Unlimited play. <span className={styles.underline}>No subscriptions.</span>
                </p>
            </div>
        </section>
    );
};

export default HeroTagline;
